import React, { useState, useRef, useEffect } from "react";
import {
  Collapse,
  Input,
  Button,
  Flex,
  Form,
  Switch,
  Typography,
  Select
} from "antd";
import {
  MinusCircleOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  LockOutlined,
} from "@ant-design/icons";

import globalData from "../../config/global_data";

const { Text } = Typography;

const CreateAttributeList = ({ setSavedattributes }) => {
  const [attributes, setAttributes] = useState([]);
  useEffect(() => {
    return () => {
      const updated = [...attributes];

      updated.forEach((attr, attrIndex) => {
        // Go backwards to safely remove items while looping
        for (let valIndex = attr.values.length - 1; valIndex >= 0; valIndex--) {
          if (!attr.values[valIndex] || attr.values[valIndex].trim() === "") {
            removeValue(attrIndex, valIndex);
          }
        }
      });
    };
  }, []);
  useEffect(() => {
    setSavedattributes({ custom_fields: attributes });
  }, [attributes, setSavedattributes]);

  useEffect(() => {
    const fetch = async () => {
      if (
        globalData &&
        globalData.attribute_tree &&
        globalData.attribute_tree.length > 0
      ) {
        const mappedData = await globalData.attribute_tree.map((item, index) => {
          let values_mapped=[]
          if (item.attribute_element_type == "dropdown" && item.values_data && item.values_data.length > 0) {
            values_mapped = item.values_data.map((item2) => ({
              value: item2.values,
              label: item2.values
            }))
           
          }
          return ({
            name: item.name,
            values: [],
            max_size: item.max_size,
            min_size: item.min_size,
            is_required: item.is_required,
            attribute_element_type: item.attribute_element_type,
            attribute_key: item.attribute_key,
            id: item.id,
            store_id: item.store_id,
            info_text: item.info_text,
            pattern: item.attri_pattern,
            values_mapped,
            selected_values: []
          })

        })
        setAttributes(mappedData);
      }
    }
    fetch()
  }, []);

  const dragItem = useRef();
  const dragOverItem = useRef();

  const handleSort = () => {
    const currentItem = attributes[dragItem.current];
    const updatedItems = [...attributes];
    updatedItems.splice(dragItem.current, 1);
    updatedItems.splice(dragOverItem.current, 0, currentItem);

    setAttributes(updatedItems);
    dragItem.current = null;
    dragOverItem.current = null;
  };

  const addAttribute = () => {
    setAttributes([
      ...attributes,
      {
        name: `New Attribute ${attributes.length + 1}`,
        values: [""],
        isEditable: true,
      },
    ]);
  };

  const updateAttributeName = (index, newName) => {
    const updated = [...attributes];
    updated[index].name = newName;
    setAttributes(updated);
  };

  const updateValue = (attrIndex, valIndex, newValue) => {
    const updated = [...attributes];
    updated[attrIndex].values[valIndex] = newValue;
    setAttributes(updated);
  };

  const addValue = (attrIndex) => {
    const updated = [...attributes];
    updated[attrIndex].values.push("");
    setAttributes(updated);
  };

  const removeValue = (attrIndex, valIndex) => {
    const updated = [...attributes];
    updated[attrIndex].values.splice(valIndex, 1);
    setAttributes(updated);
  };

  const removeAttribute = (index) => {
    const updated = attributes.filter((_, i) => i !== index);
    setAttributes(updated);
  };
  const handleValuesChange = (e, attrIndex) => {
    attributes[attrIndex].selected_values = e;
    if(attributes[attrIndex].values && attributes[attrIndex].values.length>0){
      attributes[attrIndex].values[0] = e.join(",");
    }else{
      attributes[attrIndex].values=[e.join(",")]
    }    
    const updated = [...attributes];
    setAttributes(updated);
  };

  const innerCollapseItems = attributes.map((attribute, index) => {
    const isDraggable = attribute.name !== "Main Information";

    return {
      key: attribute.name,
      label: attribute.name,
      children: (
        <div
          className="panelname"
          {...(isDraggable && {
            draggable: true,
            onDragStart: () => (dragItem.current = index),
            onDragEnter: () => (dragOverItem.current = index),
            onDragEnd: handleSort,
            onDragOver: (e) => e.preventDefault(),
          })}
        >
          <Form.Item
            className="attributeFormItemName"
            label={
              <span>
                Attribute Name&nbsp;
                {/* <QuestionCircleOutlined
                  style={{
                    color: "rgba(0, 0, 0, 0.45)",
                    cursor: "pointer",
                  }}
                  title="This is the Attribute Name."
                /> */}
              </span>
            }
            style={{ marginBottom: 8 }}
            name={attribute.name}
          >
            <Input
              value={attribute.name}
              onChange={(e) => updateAttributeName(index, e.target.value)}
              placeholder={attribute.name}
              suffix={!attribute.isEditable && <LockOutlined />}
              disabled={!attribute.isEditable}
            />
          </Form.Item>

          {attribute.attribute_element_type !== "dropdown" && attribute.values.map((value, valIndex) => (
            <Form.Item
              className="attributeFormItem"
              key={valIndex}
              label={
                <span>
                  Value {valIndex + 1}&nbsp;
                  {/* <QuestionCircleOutlined
                    style={{
                      color: "rgba(0, 0, 0, 0.45)",
                      cursor: "pointer",
                    }}
                    title="This is the Attribute Value."
                  /> */}
                </span>
              }
              style={{ marginBottom: 8 }}
            // name="Attribute Value"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please enter Attribute Value",
            //   },
            // ]}
            >
              <Flex
                style={{
                  display: "flex",
                  paddingBottom: "20px",
                  width: "100%",
                }}
                align="start"
                size={8}
              >
                <div style={{ width: "100%" }}>
                  <Input.TextArea
                    value={value}
                    onChange={(e) =>
                      updateValue(index, valIndex, e.target.value)
                    }
                    maxLength={250}
                    style={{ width: "100%" }}
                    showCount={{
                      formatter: ({ count, maxLength }) =>
                        `${count}/${maxLength} characters`,
                    }}
                  />
                </div>
                {attribute.values.length > 1 && (
                  <Button
                    type="text"
                    danger
                    icon={<MinusCircleOutlined />}
                    onClick={() => removeValue(index, valIndex)}
                    style={{ width: 32, padding: 0 }}
                  />
                )}
              </Flex>
            </Form.Item>
          ))}
          {attribute.attribute_element_type === "dropdown" &&
            <Form.Item
              label={
                <span>
                  Values&nbsp;
                  {/* <QuestionCircleOutlined
                    style={{
                      color: "rgba(0, 0, 0, 0.45)",
                      cursor: "pointer",
                    }}
                    title="This is the SAP SKU."
                  /> */}
                </span>
              }
              className="attribute_values dropdown_values"
            >
              <Select
                mode="multiple"
                optionFilterProp="label"
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Select Values"
                defaultValue={attribute.selected_values}
                onChange={e => handleValuesChange(e, index)}
                options={attribute.values_mapped}
              />
            </Form.Item>
          }

          {attribute.attribute_element_type !== "dropdown" && <div className="btnBox">
            <Button
              disabled={attribute.max_size <= attribute.values.length}
              onClick={() => addValue(index)}
              icon={<PlusOutlined />}
            >
              Add a value
            </Button>
          </div>}

          <div className="SwitchBox">
            <Switch defaultChecked disabled />
            <Text className="SwitchText">Visible on PDP</Text>
          </div>
        </div>
      ),
    };
  });

  return (
    <Collapse
      defaultActiveKey={["product-page-details"]}
      items={[
        {
          key: "product-page-details",
          label: "Product page details",
          children: (
            <Collapse defaultActiveKey={["0"]} items={innerCollapseItems} />
          ),
        },
      ]}
    />
  );
};

export default CreateAttributeList;
